import { createAsyncThunk } from "@reduxjs/toolkit";
import { contactSupportService } from "../services/contactSupport.service";
import { ContactSupportPayload } from "../interfaces/contactSupport.interface";
import { ApiError } from "../../../utils/api/api.service";

export const submitContactSupport = createAsyncThunk<
  void,
  ContactSupportPayload,
  { rejectValue: string }
>(
  "contactSupport/submit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await contactSupportService.submitMessage(payload);
      const data = response as { success?: boolean; message?: string } | undefined;
      if (data?.success !== true) {
        return rejectWithValue(
          data?.message || "We could not send your message. Please check the email entered and try again later."
        );
      }
    } catch (error: unknown) {
      if (error instanceof ApiError) {
        return rejectWithValue(error.message);
      }
      if (error instanceof Error) {
        return rejectWithValue(error.message || "An unexpected error occurred");
      }
      return rejectWithValue("An unexpected error occurred");
    }
  }
);
